module.exports = __webpack_public_path__ + "static/assets/6bc8ca5591411ebe64c21a3b4916fb10.png";